import { HttpService } from '@/data/http/http-service';
import { ImpactCo2Answer } from '@/domain/impact-co2/entities/question.entity';

import { buildUrl } from './utils/build-url-from-category';

const http = new HttpService({ baseURL: import.meta.env.VITE_API_IMPACT });

export async function deleteImpactAnswer(
  answer: ImpactCo2Answer,
): Promise<void> {
  const url = `${buildUrl(answer.category)}/${answer.id}`;
  const response = await http.delete(url);
  if (response.status === 200) {
    return;
  } else {
    throw 'error on delete';
  }
}
